module.exports = __webpack_public_path__ + "media/images/r_wijnveen-01e4d7da4b2c09411ccf8e52d74c3496.png";